<template>
  <div v-loading="initLoading">
  <div class="ReportDetailPage" style="width: 700px;background-color: #fafafa;padding: 20px">
    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }" >数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/ReportDetailPage' }" >明细报表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="font-size: 25px;margin-top: 15px;">
      <p>销售明细（已发放红利）</p>
    </div>
    <div style="width: 700px; font-family: 宋体; font-size: 25px;font-weight: bold">
      <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" style=" margin-top: 30px;width: 300px" >
        <el-form-item label="发放时间" prop="value1" style="width: 700px">
          <el-date-picker
            v-model="ruleForm2.startDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="开始日期"
            :picker-options="pickerOptions0">
          </el-date-picker>
          <el-date-picker
            v-model="ruleForm2.endDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="结束日期"
            :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="供应商" prop="selectedSupplierIds">
          <el-select clearable v-model="ruleForm2.selectedSupplierIds" popper-class="el-select" value-key="id" filterable multiple placeholder="必选"  @change="supplierid" style="width: 400px">
            <select-all-option @change="supplierid" v-if="userSupplierId == null" v-model="ruleForm2.selectedSupplierIds" :data="user" :autoSelect="true"/>
            <el-option
              v-for="item in user"
              :key="item.id"
              :label="item.name"
              :value='item'
              :disabled="dashboardSales && item.id != userSupplierId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌" prop="selectParentBrands" >
          <el-select clearable v-model="ruleForm2.selectedParentBrands" popper-class="el-select" multiple placeholder="可筛选，不筛选则导出全部" style="width: 400px;color: #EF6C00" value-key="parentBrand"  @change="selectParentBrandss" :disabled="ruleForm2.selectedSupplierIds.length == 0">
            <select-all-option @change="selectParentBrandss" v-model="ruleForm2.selectedParentBrands" group-value="brands" :data="dataInfos"/>
            <el-option-group
              v-for="group in dataInfos"
              :key="group.id"
              :label="group.name" style="white-space: pre-wrap">
              <el-option
                v-for="item in group.brands"
                :key="item.id"
                :label="item.parentBrand"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="品类" prop="selectBrands">
          <el-select popper-class="el-select" v-model.number="ruleForm2.selectedBrands" multiple placeholder="可筛选，不筛选则导出全部" style="width: 400px" value-key="id"  @change="selectBrandss" :disabled="ruleForm2.selectedParentBrands.length == 0">
            <select-all-option @change="selectBrandss" v-model="ruleForm2.selectedBrands" group-value="brand" :data="selectBrands"/>
            <el-option-group
              v-for="group in selectBrands"
              :key="group.id"
              :label="group.parentBrand">
              <el-option
                v-for="(item) in group.brand"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="产品" prop="selectProducts">
          <el-select popper-class="el-select" v-model.number="ruleForm2.selectedProducts" multiple placeholder="可筛选，不筛选则导出全部"  value-key="id" style="width: 400px" :disabled="ruleForm2.selectedBrands.length == 0">
            <select-all-option v-model="ruleForm2.selectedProducts" group-value="products" :data="selectProducts"/>
            <el-option-group
              v-for="group in selectProducts"
              :key="group.id"
              :label="group.name">
              <el-option
                v-for="item in group.products"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="区域" prop="selectRegionals">
          <el-select popper-class="el-select" v-model.number="ruleForm2.selectedRegionals" multiple style="width: 400px" value-key="id" @change="selectRegionalss" placeholder="可筛选，不筛选则导出全部" :disabled="ruleForm2.selectedSupplierIds.length == 0">
            <select-all-option @change="selectRegionalss" v-model="ruleForm2.selectedRegionals" group-value="regionals" :data="selectRegionals"/>
            <el-option-group
              v-for="group in selectRegionals"
              :key="group.name"
              :label="group.name">
              <el-option
                v-for="item in group.regionals"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="省份" prop="selectProvinces">
          <el-select popper-class="el-select" v-model.number="ruleForm2.selectedProvinces"  style="width: 400px" value-key="id" multiple placeholder="可筛选，不筛选则导出全部" :disabled="ruleForm2.selectedRegionals.length == 0">
            <select-all-option v-model="ruleForm2.selectedProvinces" group-value="children" :data="selectProvinces"/>
            <el-option-group
              v-for="group in selectProvinces"
              :key="group.name"
              :label="group.name">
              <el-option
                v-for="item in group.children"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="margin-left: 100px">
        <div class="el-dropdown dropdown" v-if="loading" style="position: relative; display: inline-block;">
          <el-button-group class="el-dropdown-selfdefine">
            <el-button type="primary" :loading="loading">导出销售明细</el-button>
            <el-button type="primary" class="el-dropdown__caret-button is-loading">
              <i class="el-dropdown__icon el-icon-arrow-down"/>
            </el-button>
          </el-button-group>
        </div>
        <el-dropdown split-button type="primary" @click="excel()" @command="openWeekly()" trigger="click" v-else>
          导出销售明细
          <el-dropdown-menu slot="dropdown" class="dropdown-menu">
            <el-dropdown-item>导出周均对比</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button style="color: white; variant:'outlined';border-color: #FF6633; background-color: #FF6633;margin-left: 10px" :loading="loading" @click="openDetail">在线查看</el-button>
        <el-button style="color: white; variant:'outlined';border-color: #FF6633; background-color: #FF6633" :loading="loadings"  @click="dialogFormVisible = true">推送邮件</el-button>
      </div>
    </div>
    <!-- Form -->
    <el-dialog title="请选择你需要推送到的邮箱" :visible.sync="dialogFormVisible"   center width="30%">
      <el-select v-model="ruleForm2.javaMail" placeholder="请选择通路管理助手的注册用户" style="width: 100%;">
        <el-option
          v-for="item in options"
          :key="item.emailAddress"
          :label="(item.name+item.emailAddress)"
          :value="item.emailAddress">
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button  style="width: 40%;background-color: #EF6C00;color: white "  @click="dialogFormVisible = false">取 消</el-button>
        <el-button style="width: 40%;background-color: #EF6C00;color: white " @click="dialogFormVisibles()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="detailDialog.visible"
      width="1500px"
      class="details"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center>
      <div v-loading="detailDialog.loading">
        <div slot="title" class="dialog-title" style="text-align: center;margin-bottom: 20px">销售明细</div>
        <div style="text-align: center">
          <div style="text-align: left">
            <div style="font-weight: bold; font-size: 18px; line-height: 25px; ">筛选条件</div>
            <div class="flex-row" style="text-align: left;justify-content: left">
              <div>
                <span style="font-weight: bold">发放时间：</span>
                <el-date-picker
                  size="mini"
                  style="width: 130px"
                  v-model="detailDialog.params.startDate"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                  :clearable="false"
                  :editable="false"
                  @change="detailDateChange"
                  :picker-options="pickerOptions2">
                </el-date-picker>
                <span style="color: #39393B;">&nbsp;-&nbsp;</span>
                <el-date-picker
                  size="mini"
                  style="width: 130px"
                  v-model="detailDialog.params.endDate"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="结束日期"
                  :clearable="false"
                  :editable="false"
                  @change="detailDateChange"
                  :picker-options="pickerOptions3">
                </el-date-picker>
              </div>
              <div><span style="font-weight: bold">供应商：</span>{{detailDialog.params.supplier}}</div>
              <div v-if="detailDialog.params.brand"><span style="font-weight: bold">品牌：</span>{{detailDialog.params.brand}}</div>
              <div v-if="detailDialog.params.category"><span style="font-weight: bold">品类：</span>{{detailDialog.params.category}}</div>
              <div v-if="detailDialog.params.product"><span style="font-weight: bold">产品：</span>{{detailDialog.params.product}}</div>
              <div v-if="detailDialog.params.region"><span style="font-weight: bold">区域：</span>{{detailDialog.params.region}}</div>
              <div v-if="detailDialog.params.province"><span style="font-weight: bold">省份：</span>{{detailDialog.params.province}}</div>
            </div>
          </div>
          <div style="margin-top: 10px">
            <div style="font-weight: bold; font-size: 18px;text-align: left">数据报表</div>
            <div class="flex-row">
              <div style="text-align: left;line-height: 25px">合计销售数量：<span style="color: #EF6C00">{{this.detailDialog.productCount}}</span>，合计销售金额：<span style="color: #EF6C00">{{this.detailDialog.sumSalePrice}}</span>，合计红利金额：<span style="color: #EF6C00">{{this.detailDialog.bonus}}</span></div>
              <el-button icon="el-icon-s-tools" size="mini" @click="openCustomColumn" style="border-bottom: none;border-bottom-left-radius: 0;border-bottom-right-radius: 0;" plain>自定义列</el-button>
            </div>
          </div>
          <el-table
            :data="detailDialog.tableData"
            border
            @sort-change="detailSort"
            :header-cell-style="handleTheadStyle"
            :height="windowHeight/1.5"
            style="width: 100%">
            <el-table-column
              width="50"
              label="序号" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              v-for="item in detailDialog.groupList"
              :prop="item"
              :label="columnList.find(c => c.value === item).label"
              :min-width="columnList.find(c => c.value === item).miniWidth"
              sortable="custom"
              align="center">
              <template slot-scope="scope">
                <div v-if="item === 'processId' && scope.row['processId'].length > 15">
                  <el-tooltip effect="dark" :content="scope.row['processId']" placement="top-start">
                    <div>{{scope.row['processId'].substring(0,15) + '...'}}</div>
                  </el-tooltip>
                </div>
                <div v-else>{{scope.row[item]}}</div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="padding-bottom: 20px"
            @size-change="(pageSize) => pageDetail(1,pageSize)"
            @current-change="(pageNum) => pageDetail(pageNum)"
            :page-sizes="[10,20,50,100]"
            :page-size="detailDialog.pageSize"
            :current-page="detailDialog.pageNum"
            layout="sizes, prev, pager, next"
            :total="detailDialog.totalCount">
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="detailDialog.customColumn"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
      class="details"
      center>
      <div slot="title" class="dialog-title" style="text-align: center">自定义列</div>
      <div style="margin-top: 20px">
        <el-checkbox-group v-model="detailDialog.columnList" @change="refreshColumnList">
          <el-checkbox style="margin-bottom: 20px" :label="item.value" v-if="item.display" v-for="item in columnList">{{item.label}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div style="text-align: center;padding-bottom: 20px">
        <el-button type="primary" plain size="small" style="margin-right: 30px;" @click="refreshDetail">添加</el-button>
        <el-button size="small" @click="cleanDetail">清空重置</el-button>
      </div>
    </el-dialog>
    </div>
    <el-dialog title="导出周均对比" width="600px" :visible.sync="weeklyVisible" :close-on-press-escape="false" :close-on-click-modal="false">
      <el-form :model="weeklyForm" style="font-family: 宋体; font-size: 25px;font-weight: bold">
        <el-form-item label="请选择需对比的周期：" style="margin-bottom: 0">
          <el-date-picker
            v-model="weeklyForm.range"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions4"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <div style="margin-left: 155px">
            <span>同时导出销售明细</span>&nbsp;<el-checkbox v-model="weeklyForm.downDetails"/>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="weeklyVisible = false" :loading="loading">取 消</el-button>
        <el-button type="primary" @click="weeklyExcel" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  allUser,
  cacheExcel,
  downloadDataJson,
  Mail,
  Mailselect,
  queryReportDetail,
  queryWeeklyReport
} from '@/api/ReportDetailPage'
import selectAllOption from '@/components/selectAllOption'

export default {
  components: {selectAllOption},
  data () {
    return {
      // 判断时间的限制
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.ruleForm2.endDate) {
            return time.getTime() > Math.min(new Date(this.ruleForm2.endDate).getTime(),new Date(this.umEndDate).getTime()) || time.getTime() < new Date(this.umStartDate).getTime() - 86400000
          } else {
            return time.getTime() < new Date(this.umStartDate).getTime() - 86400000 || time.getTime() > new Date(this.umEndDate).getTime()
          }
        }
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if (this.ruleForm2.startDate) {
            return time.getTime() < Math.max(new Date(this.ruleForm2.startDate).getTime(),new Date(this.umStartDate).getTime()) || time.getTime() > new Date(this.umEndDate).getTime()
          } else {
            return time.getTime() < new Date(this.umStartDate).getTime() - 86400000 || time.getTime() > new Date(this.umEndDate).getTime()
          }
        }
      },
      pickerOptions2: {
        disabledDate: (time) => {
          if (this.ruleForm2.startDate && this.ruleForm2.endDate) {
            const time1 = time.getTime()
            const time2 = new Date(new Date(this.ruleForm2.startDate).getTime() - 24 * 60 * 60 * 1000).getTime();
            const time3 = new Date(this.ruleForm2.endDate).getTime()
            const time4 = new Date(this.detailDialog.params.endDate).getTime()
            return time1 < time2 || time1 > time3 || time1 > time4
          }
          return true
        }
      },
      pickerOptions3: {
        disabledDate: (time) => {
          if (this.ruleForm2.startDate && this.ruleForm2.endDate) {
            const time1 = time.getTime()
            const time2 = new Date(this.ruleForm2.startDate).getTime()
            const time3 = new Date(this.ruleForm2.endDate).getTime()
            const time4 = new Date(this.detailDialog.params.startDate).getTime()
            return time1 < time2 || time1 > time3 || time1 < time4
          }
          return true
        }
      },
      pickerOptions4: {
        disabledDate: (time) => {
          return time.getTime() > new Date().getTime()
        }
      },
      ruleForm2: {
        selectedSupplierIds: [],
        endDate: null,
        startDate: null,
        selectedParentBrands: [],
        selectedBrands: [],
        selectedProducts: [],
        selectedRegionals: [],
        selectedProvinces: [],
        javaMail: '',
        columnList:[]
      },
      // 判断供应商是否选择
      rules2: {
        selectedSupplierIds: [
          { required: true, message: '请至少选择一个供应商', trigger: 'change' }
        ]
      },
      user: [],
      value: '',
      selectParentBrands: [ { brands: [] } ],
      selectBrands: [],
      selectProducts: [],
      selectRegionals: [],
      selectProvinces: [],
      token: '',
      selectedSupplierId: [],
      dataInfos: [],
      loading: false,
      loadings: false,
      options: [],
      dialogFormVisible: false,
      userSupplierId:'',
      dashboardSales: false,
      initLoading:true,
      columnList: [],
      detailDialog: {
        params:{}
      },
      umStartDate: null,
      umEndDate: null,
      windowHeight: window.innerHeight,
      weeklyVisible: false,
      weeklyForm: {range: [],endDate: null, startDate: null,downDetails: true}
    }
  },
  created () {
    // 进入测页面以后 查询出下拉框的所有值
    this.allUser()
    // 进入测页面以后 查询出符合要求的邮箱地址
    this.Mailselect()
    this.userSupplierId = localStorage.getItem("userSupplierId");
    this.dashboardSales = localStorage.getItem('dashboardSales') == 2
    this.$store.commit('addTips',['大部分字段可选择性填写，若不填写则表示导出全部。可选填的字段包括[品牌]、[品类]、[产品]、[区域]、[省份]'])

  },
  methods: {
    supplierids (lists) {
      // 合并数组对象中key相同的数据
      let dataInfo = []
      let dataInfos = []
      lists.forEach((item1, index) => {
        let data = {
          id : index,
          name : item1.name,
          brands : []
        }
        let data1 = {
          id : index+".",
          name : item1.name,
          brands : []
        }
        let countSame = []
        item1.brands.forEach((item, index) => {
          let { parentBrand } = item
          dataInfo.forEach(a1 => {
            a1.brands.forEach(b1 => {
              // 当不同供应商底下品牌相同的情况下
              if (parentBrand === b1.parentBrand) {
                // 保存相同品牌数据
                countSame.push(parentBrand)
              }
            })
          })
          if (!data.brands[parentBrand]) {
            data.brands[parentBrand] = {
              id: item.id,
              parentBrand: item.parentBrand,
              brand: [{
                id: item.pid,
                name: item.name,
                products: item.products
              }]
            }
          }else if (data.brands[parentBrand]) {
            data.brands[parentBrand].brand.push({
              id: item.pid,
              name: item.name,
              products: item.products
            })
          }
        })
        let list=Object.values(data.brands)
        data.brands=list
        dataInfo.push(data)
        // 构造一个相同的
        const res2 = new Map();
        countSame = countSame.filter((co) => !res2.has(co) && res2.set(co, 1))
        if (countSame.length > 0) {
          countSame.forEach(cs => {
            var names = ""
            let parentBrands = []
            dataInfo.forEach((a,indexs) => {
              a.brands.forEach((b,index) => {
                if (b.parentBrand === cs) {
                  if (names.substr(names.length-1,3) === "\n") {
                    names+=a.name
                  } else {
                    names+=a.name+"\n"
                  }
                  if (!data1.brands[b.parentBrand]) {
                    data1.brands[b.parentBrand] = {
                      id: b.id,
                      parentBrand: b.parentBrand,
                      brand: b.brand
                    }
                  } else {
                    b.brand.forEach(brand => {
                      data1.brands[b.parentBrand].brand.push({
                        id: brand.id,
                        name: brand.name,
                        products: brand.products
                      })
                    })
                    // 去重
                    const res = new Map();
                    data1.brands[b.parentBrand].brand = data1.brands[b.parentBrand].brand.filter((f) => !res.has(f.name) && res.set(f.name, 1))
                  }
                  a.brands.splice(index,1)
                }
                if (data1.brands[b.parentBrand] !== undefined) {
                  parentBrands[b.parentBrand] = data1.brands[b.parentBrand]
                }
              })
            })
            if (names !== null && parentBrands[cs] !== undefined) {
              let lists=Object.values(parentBrands)
              if (lists.length !== 0) {
                data1.brands=lists
                data1.name = names
                dataInfo.push(data1)
                dataInfo = JSON.parse(JSON.stringify(dataInfo))
              }
            }
          })
        }
      })
      // 过滤掉品牌为空的
      dataInfo.forEach(da => {
        if (da.brands.length !== 0) {
          let datas = {
            id : da.id,
            name : da.name,
            brands : da.brands
          }
          dataInfos.push(datas)
        }
      })
      dataInfos.forEach((das,index) => {
        if (das.name.indexOf("\n") !== -1) {
          dataInfos.unshift(dataInfos.splice(index,1)[0])
        }
      })
      this.dataInfos = dataInfos
    },
    supplierid () {
      // 根据选择的供应商赋值给品牌和区域
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm2.selectedSupplierIds.length > 0) {
        this.selectParentBrands = this.ruleForm2.selectedSupplierIds
        this.supplierids(this.selectParentBrands)
        this.selectRegionals = this.ruleForm2.selectedSupplierIds
        let parentBrands=[];
        if (this.ruleForm2.selectedParentBrands.length > 0){
          this.ruleForm2.selectedParentBrands.forEach((item, index) => {
            this.selectParentBrands.forEach((e, i) => {
              e.brands.forEach((t, m) => {
                if(item.parentBrand == t.parentBrand){
                  parentBrands[item.parentBrand]=item
                }
              })
            })
          })
          this.ruleForm2.selectedParentBrands = Object.values(parentBrands);
          this.selectParentBrandss ()
        }
      } else {
        this.ruleForm2.selectedParentBrands = []
        this.ruleForm2.selectedBrands = []
        this.ruleForm2.selectedProducts = []
        this.ruleForm2.selectedRegionals = []
        this.ruleForm2.selectedProvinces = []
      }
    },
    selectParentBrandss () {
      // 根据选择的品牌赋值给品类
      if (this.ruleForm2.selectedParentBrands.length > 0) {
        this.selectBrands = this.ruleForm2.selectedParentBrands
        let selectedBrands=[]
        if (this.ruleForm2.selectedBrands.length > 0){
          this.ruleForm2.selectedBrands.forEach((item, index) => {
            this.selectBrands.forEach((t, i) => {
              t.brand.forEach((e, j) => {
                if(item.id == e.id){
                  selectedBrands[item.id]=item;
                }
              })
            })
          })
          this.ruleForm2.selectedBrands = Object.values(selectedBrands)
          this. selectBrandss ()
        }
      } else {
        this.ruleForm2.selectedBrands = []
        this.ruleForm2.selectedProducts = []
      }
    },
    selectBrandss () {
      // 根据选择的品类赋值给产品
      if (this.ruleForm2.selectedBrands.length > 0) {
        this.selectProducts = this.ruleForm2.selectedBrands
        let selectedProducts=[]
        if (this.ruleForm2.selectedProducts !=''){
          this.ruleForm2.selectedProducts.forEach((item, index) => {
            this.selectProducts.forEach((t, i) => {
              t.products.forEach((e, j) => {
                if (e.id == item.id){
                  selectedProducts[item.id]=item
                }
              })
            })
          })
          this.ruleForm2.selectedProducts = Object.values(selectedProducts)
        }
      } else {
        this.ruleForm2.selectedProducts = []
      }
    },
    selectRegionalss () {
      // 根据选择的区域赋值给不同的省份
      if (this.ruleForm2.selectedRegionals.length > 0&& this.ruleForm2.selectedRegionals.length >0) {
        this.selectProvinces = this.ruleForm2.selectedRegionals
      }else {
        this.ruleForm2.selectedProvinces = []
      }
    },
    allUser () {
      this.token = localStorage.getItem('token')
      allUser(this.token, localStorage.getItem('dashboardSales') == 1 ? null : localStorage.getItem('userSupplierId')).then(res => {
        if (res.data.suppliers != null) {
          this.user = res.data.suppliers
          this.umStartDate = res.data.umStartDate
          this.umEndDate = res.data.umEndDate
          this.ruleForm2.endDate = this.getNowTime()
          this.ruleForm2.startDate = this.getStartTime()
        }
        this.initLoading = false
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      })
    },
    excel () {
      this.token = localStorage.getItem('token')
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm2.selectedSupplierIds .length > 0) {
        // eslint-disable-next-line eqeqeq
        // if (this.ruleForm2.selectedBrands.length > 0) {
        //   this.ruleForm2.selectedBrands = this.ruleForm2.selectedParentBrands
        // }
        this.loading = true
        cacheExcel(this.token, this.ruleForm2,localStorage.getItem('managerId')).then(re => {
          re = re.data
          if (re.code === 301) {
            this.$notify.error({
              message: re.msg,
              title: '失败',
              position: 'bottom-right'
            })
            this.loading = false
          } else if (re.code === 200) {
            if (re !== null) {
              window.location.href = re.date;
              this.$notify({
                type: 'success',
                message: '销售明细导出成功',
                title: '成功',
                position: 'bottom-right'
              })
            }
          }
        }).catch(error => {
          let status = error.response.status;
          if (status == 500) {
            this.$notify.error({
              title: '错误',
              message: '导出失败，请联系管理员',
              position: 'bottom-right'
            })
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    },
    weeklyExcel() {
      this.token = localStorage.getItem('token')
      const range = this.weeklyForm.range;
      if (range && range.length === 2) {
        this.loading = true
        this.weeklyForm.startDate = range[0]
        this.weeklyForm.endDate = range[1]
        queryWeeklyReport(this.token, this.weeklyForm,localStorage.getItem('managerId')).then(re => {
          re = re.data
          if (re && re.code === 200) {
            window.location.href = re.date;
            if (this.weeklyForm.downDetails) {
              const date = new Date()
              const year = date.getFullYear()
              const month = String(date.getMonth() + 1).padStart(2, '0')
              const day = String(date.getDate()).padStart(2, '0')
              this.weeklyForm.endDate = `${year}-${month}-${day}`
              cacheExcel(this.token, this.weeklyForm,localStorage.getItem('managerId')).then(re2 => {
                re2 = re2.data
                if (re2 && re2.code === 200) {
                  window.location.href = re2.date
                  this.weeklyVisible = false
                  this.loading = false
                  this.$notify({
                    type: 'success',
                    message: '周均对比和销售明细导出成功',
                    title: '成功',
                    position: 'bottom-right'
                  })
                }
              })
            } else {
              this.loading = false
              this.weeklyVisible = false
              this.$notify({
                type: 'success',
                message: '周均对比导出成功',
                title: '成功',
                position: 'bottom-right'
              })
            }
          } else {
            this.loading = false
          }
        }).catch(error => {
          this.loading = false
          let status = error.response.status;
          if (status == 500) {
            this.$notify.error({
              title: '错误',
              message: '导出失败，请联系管理员',
              position: 'bottom-right'
            })
          }
        })
      } else {
        this.$notify({
          title: '警告',
          message: '请选择需对比的周期',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    },
    // 处理默认选中当前日期
    getNowTime () {
      let now = new Date(Math.min(new Date().getTime(), new Date(this.umEndDate).getTime()))
      let year = now.getFullYear() // 得到年份
      let month = now.getMonth() // 得到月份
      let date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      let defaultDate = `${year}-${month}-${date}`
      return defaultDate
      // this.$set(this.ruleForm2, 'endDate', defaultDate)
    },
    getStartTime(){
      let now = new Date(this.ruleForm2.endDate)
      now = new Date(now.getTime() + 24*3600*1000)
      now.setMonth(now.getMonth()-1);
      now = new Date(Math.max(now.getTime(),new Date(this.umStartDate).getTime()))
      let year = now.getFullYear() // 得到年份
      let month = now.getMonth() // 得到月份
      let date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      let defaultDate = `${year}-${month}-${date}`
      return defaultDate
    },
    handleDownload (res) {
      // 创建下载的链接
      // 设置该文件的mime类型，这里对应的mime类型对应为.xlsx格式
      let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    dialogFormVisibles () {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm2.selectedSupplierIds .length > 0) {
        // eslint-disable-next-line eqeqeq
        if (this.ruleForm2.javaMail .length > 0) {
          this.dialogFormVisible = false
          // eslint-disable-next-line eqeqeq
          if (this.ruleForm2.selectedBrands .length > 0) {
          } else {
            this.ruleForm2.selectedBrands = this.ruleForm2.selectedParentBrands
          }
          this.loadings = true
          Mail(this.token, this.ruleForm2,localStorage.getItem('managerId')).then(res => {
            if (res !== null) {
              if (res.status === 200) {
                this.$notify({
                  type: 'success',
                  message: '推送成功',
                  title: '成功',
                  position: 'bottom-right'
                })
                this.loadings = false
              }
            }
          }).catch(error => {
            let status = error.response.status;
            if (status == 500){
              this.open4()
            }
            this.loadings = false
          })
        } else {
          this.$notify({
            title: '警告',
            message: '请至少选择一个邮箱地址',
            type: 'warning',
            position: 'bottom-right'
          })
        }
      } else {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    },
    open4 () {
      this.$notify.error({
        title: '错误',
        message: '推送失败，请联系管理员',
        position: 'bottom-right'
      })
    },
    Mailselect () {
      Mailselect(this.token).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.data != '') {
          this.options = res.data
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500){
          this.$notify.error({
            title: '错误',
            message: '邮箱地址获取失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      })
    },
    openDetail() {
      if (this.ruleForm2.selectedSupplierIds.length > 0) {
        const supplier = (this.ruleForm2.selectedSupplierIds.length > 1 && this.ruleForm2.selectedSupplierIds.length === this.user.length) ? null : this.ruleForm2.selectedSupplierIds.map(item => item.name).join('，')
        const brand = (this.ruleForm2.selectedParentBrands.length > 1 && this.ruleForm2.selectedParentBrands.length === this.dataInfos.flatMap(bArray =>
          bArray.brands.flatMap(dArray => dArray)).flat().flat().length) ? null : this.ruleForm2.selectedParentBrands.map(item => item.parentBrand).join('，')
        const category = (this.ruleForm2.selectedBrands.length > 1 && this.ruleForm2.selectedBrands.length === this.selectBrands.flatMap(bArray =>
          bArray.brand.flatMap(dArray => dArray)).flat().flat().length) ? null : this.ruleForm2.selectedBrands.map(item => item.name).join('，')
        const product = (this.ruleForm2.selectedProducts.length > 1 && this.ruleForm2.selectedProducts.length === this.selectProducts.flatMap(bArray =>
          bArray.products.flatMap(dArray => dArray)).flat().flat().length) ? null : this.ruleForm2.selectedProducts.map(item => item.name).join('，')
        const region = (this.ruleForm2.selectedRegionals.length > 1 && this.ruleForm2.selectedRegionals.length === this.selectRegionals.flatMap(bArray =>
          bArray.regionals.flatMap(dArray => dArray)).flat().flat().length) ? null : this.ruleForm2.selectedRegionals.map(item => item.name).join('，')
        const province = (this.ruleForm2.selectedProvinces.length > 1 && this.ruleForm2.selectedProvinces.length === this.selectProvinces.flatMap(bArray =>
          bArray.children.flatMap(dArray => dArray)).flat().flat().length) ? null : this.ruleForm2.selectedProvinces.map(item => item.name).join('，')
        this.detailDialog = {
          visible: true,
          loading: false,
          columnList: ['deliverDateTime','storeBrand'],
          groupList:['deliverDateTime','storeBrand','productCount','sumSalePrice','bonus'],
          pageNum: 1,
          pageSize: 10,
          totalCount: 0,
          dataList: [],
          tableData: [],
          orderColumn: [{name:'deliverDateTime',type:'descending'},{name:'bonus',type:'descending'}],
          cacheData: [],
          productCount: 0,
          sumSalePrice: 0,
          bonus: 0,
          customColumn: false,
          params: {
            startDate: this.ruleForm2.startDate,
            endDate: this.ruleForm2.endDate,
            supplier: supplier,
            brand: brand,
            category: category,
            product: product,
            region: region,
            province: province
          }
        }
        this.columnList = [{label:'导购姓名',value:'sales',subCol: 'salesId',display: true,orderId:1},{label:'流程编号',value:'processId',display: true,orderId:2},
          {label:'发放年度',value:'deliverDateYear',display: true,orderId:3},{label:'发放月份',value:'deliverDateMonth',display: true,orderId:4},
          {label:'发放日期',value:'deliverDateTime',display: true,orderId:5},{label:'连锁品牌',value:'storeBrand',display: true,orderId:6},
          {label:'门店名称',value:'store',parent:'storeBrand',display: true,orderId:7},{label:'签约业务',value:'signManager',display: true,orderId:8},
          {label:'产品品牌',value:'parentBrand',display: true,orderId:9},{label:'产品品类',value:'brand',parent:'parentBrand',display: true,orderId:10},
          {label:'产品型号',value:'product',parent:'brand',display: true,orderId:11,miniWidth: '220'}, {label:'条形码',value:'barcode',display: true,orderId:12},
          {label:'导购ID',value:'salesId',display: false,orderId:0},{label:'销售数量',value:'productCount',display: false,disable: true,orderId:997},
          {label:'销售总额',value:'sumSalePrice',display: false,disable: true,orderId:998},{label:'发放红利金额',value:'bonus',display: false,disable: true,orderId:999}]
        this.queryDetail()
      } else {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    },
    refreshColumnList(value) {
      // 选中值变化时，更新选中状态
      this.detailDialog.columnList = value;
      // 遍历 columnList，处理 parent 和 subCol
      this.columnList.forEach(item => {
        if (item.parent && this.detailDialog.columnList.includes(item.value)) {
          // 如果子项被选中，选中父项
          this.selectParent(item.parent);
        }
        if (item.subCol && this.detailDialog.columnList.includes(item.value)) {
          // 如果子项被选中，选中子列
          this.selectSubCol(item.subCol);
        } else if (item.subCol && !this.detailDialog.columnList.includes(item.value)) {
          // 如果子项被取消选中，取消选中子列
          this.deselectSubCol(item.subCol);
        }
      })
    },
    selectParent(parentValue) {
      // 选中父项
      const parentItem = this.columnList.find(item => item.value === parentValue);
      if (parentItem && !this.detailDialog.columnList.includes(parentItem.value)) {
        this.detailDialog.columnList.push(parentItem.value);
      }
      // 递归处理上层父项
      if (parentItem && parentItem.parent) {
        this.selectParent(parentItem.parent);
      }
    },
    selectSubCol(subColValue) {
      // 选中子列
      const subColItem = this.columnList.find(item => item.value === subColValue);
      if (subColItem && !this.detailDialog.columnList.includes(subColItem.value)) {
        this.detailDialog.columnList.push(subColItem.value);
      }
    },
    deselectSubCol(subColValue) {
      const subColItem = this.columnList.find(item => item.value === subColValue);
      if (subColItem && this.detailDialog.columnList.includes(subColItem.value)) {
        this.detailDialog.columnList = this.detailDialog.columnList.filter(value => value !== subColItem.value);
      }
    },
    //刷新明细
    refreshDetail() {
      this.detailDialog.customColumn = false
      this.detailDialog.loading = true
      let groupList = this.detailDialog.columnList.concat(['productCount','sumSalePrice','bonus'])
      groupList = groupList.filter(item => !item.startsWith('deliverDate'))
      if (this.detailDialog.columnList.includes('deliverDateTime')) {
        groupList.push("deliverDateTime")
      } else if (this.detailDialog.columnList.includes('deliverDateMonth')) {
        groupList.push("deliverDateMonth")
      } else if (this.detailDialog.columnList.includes('deliverDateYear')) {
        groupList.push("deliverDateYear")
      }
      this.detailDialog.groupList = []
      this.columnList.forEach(item => {
        if (groupList.includes(item.value)) {
          this.detailDialog.groupList.push(item.value)
        }
      })
      const start = new Date(this.detailDialog.params.startDate)
      const end = new Date(this.detailDialog.params.endDate)
      const dataList = this.detailDialog.dataList.filter(item => {
        const deliverDate = new Date(item.deliverDateTime)
        return deliverDate >= start && deliverDate <= end
      })
      let productCount = 0
      let sumSalePrice = 0
      let bonus = 0
      dataList.forEach(item => {
        productCount += Number(item.productCount) || 0;
        sumSalePrice += Number(item.sumSalePrice) || 0;
        bonus += Number(item.bonus) || 0;
      })
      this.detailDialog.productCount = parseFloat(productCount.toFixed(2))
      this.detailDialog.sumSalePrice = parseFloat(sumSalePrice.toFixed(2))
      this.detailDialog.bonus = parseFloat(bonus.toFixed(2))
      this.detailDialog.pageNum = 1
      this.detailDialog.tableData = this.processArray(dataList, this.detailDialog.groupList)
      this.detailDialog.loading = false
    },
    //清除分组筛选条件，刷新明细表格
    cleanDetail() {
      this.detailDialog.columnList = ['deliverDateTime','storeBrand']
      this.detailDialog.groupList = ['deliverDateTime','storeBrand']
      this.detailDialog.customColumn = false
      this.refreshDetail()
    },
    //明细数据排序
    detailSort({prop, order}) {
      if (order) {
        this.detailDialog.orderColumn = [{name:prop,type:order}].concat(this.detailDialog.orderColumn.filter(item => item.name !== prop))
      } else {
        this.detailDialog.orderColumn = this.detailDialog.orderColumn.filter(item => item.name !== prop)
      }
      //排序
      this.detailDialog.cacheData = this.dataOrder(this.detailDialog.cacheData,this.detailDialog.orderColumn)
      //分页
      const startIndex = 0;
      const endIndex = startIndex + this.detailDialog.pageSize
      this.detailDialog.pageNum = 1
      this.detailDialog.tableData = this.detailDialog.cacheData.slice(startIndex, endIndex);
    },
    //明细数据分页
    pageDetail(pageNum,pageSize) {
      pageNum = pageNum ? pageNum : this.detailDialog.pageNum
      pageSize = pageSize ? pageSize : this.detailDialog.pageSize
      const startIndex = (pageNum - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      this.detailDialog.tableData = this.detailDialog.cacheData.slice(startIndex, endIndex);
      this.detailDialog.pageNum = pageNum
      this.detailDialog.pageSize = pageSize
    },
    //查询明细数据
    queryDetail() {
      this.token = localStorage.getItem('token')
      this.detailDialog.loading = true
      this.ruleForm2.columnList = this.columnList.map(item => item.value)
      this.ruleForm2.columnList.push('extras')
      queryReportDetail(this.token, this.ruleForm2,localStorage.getItem('managerId')).then(re => {
        downloadDataJson(re.data.date).then(res => {
          const {status,data} = res
          if (status === 200) {
            let {extras,list} = data
            let orderId = 14
            extras.forEach(item => this.columnList.push({label:item,value:item,display: true,orderId: orderId++}))
            this.columnList.sort((a,b) => a.orderId - b.orderId)
            this.detailDialog.dataList = Object.freeze(list.map(item => {
              item.deliverDateTime = item.deliverDateTime.substring(0,10)
              item['deliverDateMonth'] = item.deliverDateTime.substring(0,7)
              item['deliverDateYear'] = item.deliverDateTime.substring(0,4)
              if (item.extras && item.extras.length > 0) {
                item.extras.forEach(e => {
                  item[e.name] = e.value
                })
              }
              return item
            }))
            this.refreshDetail();
          }
        }).finally(() => {
          this.detailDialog.loading = false
        })
      }).catch(error => {
        console.log(error)
        this.detailDialog.loading = false
        let status = error.response.status;
        if (status === 500) {
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      })
    },
    //明细日期筛选
    detailDateChange(value) {
      this.refreshDetail()
    },
    //打开自定义标签
    openCustomColumn() {
      this.detailDialog.customColumn = true
      this.detailDialog.columnList = this.detailDialog.groupList.filter(item => {
        return !this.columnList.find(item2 => item2.value === item).disable
      })
    },
    //处理分组数据，生成表格显示的数据数组
    processArray(data, groupList) {
      if (!data || data.length === 0) return []
      if (!Array.isArray(data) || data.length === 0) return [];
      // 分组求和
      let groupedData = [];
      groupList = groupList.filter(g => !this.columnList.find(c => c.value === g).disable)
      if (groupList && groupList.length > 0) {
        const groupMap = new Map();
        data.forEach(item => {
          // 根据 groupList 的字段生成分组的唯一 key
          const groupKey = groupList.map(key => item[key]).join('|');
          if (!groupMap.has(groupKey)) {
            // 初始化分组对象
            const groupObj = groupList.reduce((obj, key) => {
              obj[key] = item[key];
              return obj;
            }, { productCount: 0, sumSalePrice: 0, bonus: 0 });
            groupMap.set(groupKey, groupObj);
          }
          // 累加求和字段
          const groupObj = groupMap.get(groupKey);
          groupObj.productCount += item.productCount || 0;
          groupObj.sumSalePrice += item.sumSalePrice || 0;
          groupObj.bonus += item.bonus || 0;
        });

        groupedData = Array.from(groupMap.values());
      } else {
        // groupList为空，直接对所有数据求和
        const sumObj = data.reduce((acc, item) => {
          acc.productCount += item.productCount || 0;
          acc.sumSalePrice += item.sumSalePrice || 0;
          acc.bonus += item.bonus || 0;
          return acc;
        }, { productCount: 0, sumSalePrice: 0, bonus: 0 });

        groupedData = [sumObj]; // 直接返回包含总和的数组
      }
      groupedData.forEach(item => {
        item.productCount = parseFloat(item.productCount.toFixed(2));
        item.sumSalePrice = parseFloat(item.sumSalePrice.toFixed(2));
        item.bonus = parseFloat(item.bonus.toFixed(2));
      })
      if (this.detailDialog.orderColumn.length === 0) {
        this.detailDialog.orderColumn = [{name:'deliverDateTime',type:'descending'},{name:'deliverDateMonth',type:'descending'},{name:'deliverDateYear',type:'descending'},{name:'bonus',type:'descending'}]
      }
      // 排序
      groupedData = this.dataOrder(groupedData,this.detailDialog.orderColumn)
      this.detailDialog.totalCount = groupedData.length
      this.detailDialog.cacheData = groupedData
      //分页
      const startIndex = 0;
      const endIndex = startIndex + this.detailDialog.pageSize
      return groupedData.slice(startIndex, endIndex);
    },
    dataOrder(dataList,orderColumn) {
      let orderColumn2 = orderColumn.filter(item => {return this.detailDialog.groupList.includes(item.name)})
      dataList.sort((a, b) => {
        let result;
        for (const { name, type } of orderColumn2) {
          const aValue = a[name];
          const bValue = b[name];
          if (typeof aValue === 'number' && typeof bValue === 'number') {
            // 如果都是数字，进行数值比较
            result = aValue - bValue;
          } else {
            // 如果是字符串或其他类型，使用 localeCompare 进行比较
            result = String(aValue).localeCompare(String(bValue));
          }
          if (type === 'descending') {
            result = -result;
          }
          // 如果有比较结果，返回
          if (result !== 0) {
            // 根据排序类型调整结果
            return result;
          }
        }
        return 0;
      })
      return dataList
    },
    handleTheadStyle({ column }) {
      const orderColumn = this.detailDialog.orderColumn
      if (orderColumn) {
        const item = orderColumn.find(item => item.name === column.property)
        if (item) {
          column.order =  item.type
        } else {
          column.order = null
        }
      } else {
        column.order = null
      }
    },
    openWeekly() {
      if (this.ruleForm2.selectedSupplierIds.length > 0) {
        this.weeklyVisible = true
        this.weeklyForm = {
          selectedSupplierIds: this.ruleForm2.selectedSupplierIds,
          range: [],
          startDate: null,
          endDate: null,
          downDetails: true
        }
      } else {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    }
  }
}
</script>

<style scoped>
.el-select .el-input.is-focus .el-input__inner{
  border-color: #EF6C00;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected{
  color: #EF6C00
}

.ReportDetailPage >>> .el-button--primary {
  color: #FFF;
  background-color: #FF6633;
  border-color: #FF6633;
}

.dropdown-menu >>> .popper__arrow {
  left: 103px !important;
}

.dropdown-menu {
  padding: 0 !important;
}

.dropdown-menu >>> .el-dropdown-menu__item {
   height: 40px !important;
  line-height: 40px !important;
}

.el-dropdown .is-loading {
  position: relative !important;
  pointer-events: none !important;
}

.is-loading:before {
  pointer-events: none;
  content: '';
  position: absolute;
  left: -1px;
  top: -1px;
  right: -1px;
  bottom: -1px;
  border-radius: inherit;
  background-color: rgba(255, 255, 255, .35) !important;
}

.dropdown >>> .el-dropdown__caret-button::before {
  width: unset !important;
}

.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.details >>> .el-dialog__body {
  padding-top: 0;
  padding-bottom: 0;
}

.details >>> .el-dialog__footer {
  padding-top: 0;
}

.details >>> .el-dialog {
  margin-top: 0 !important;
}

.dialog-title {
  font-size: 20px;
  font-weight: 600;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  justify-content: space-between;
  flex-wrap: wrap;
}

.flex-row > * {
  margin-right: 10px;
}

.flex-row > *:last-child {
  margin-right: 0;
}

.details >>> .el-table__body-wrapper {
  height: 82% !important;
}
</style>
